<template>
  <row class="loginForm">
    <column class="col-md-3"></column>
    <column class="col-md-6">
      <h2 class="widget-user-username" style="margin-left: 0px;">{{title}}</h2>

      <div v-if="isLocal">
        <input type="button" class="btn btn-danger" value="Fill Temp Data" style="margin-top: 20px;" @click="fillDefaultAccount()" />
      </div>

      <va-box title="Register" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-3 control-label">First Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" placeholder="First Name" v-model="firstName" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Last Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" placeholder="Last Name" v-model="lastName" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Company Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" placeholder="Company Name" v-model="companyName" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Email</label>
              <div class="col-sm-9">
                <input type="email" class="form-control" placeholder="Please choose your organization email address" v-model="username" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Confirm Email</label>
              <div class="col-sm-9">
                <input type="email" class="form-control" placeholder="Confirm Email" v-model="confirmUsername" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Password</label>
              <div class="col-sm-9">
                <input type="password" class="form-control" placeholder="Password" v-model="password" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Confirm Password</label>
              <div class="col-sm-9">
                <input type="password" class="form-control" placeholder="Confirm Password" v-model="confirmPassword" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Phone</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" placeholder="Phone (e.g. +9720503201111)" v-model="phone" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Country</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" placeholder="Country" v-model="country" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label"></label>
              <div class="col-sm-10" style="text-align: right; cursor: pointer;">
                <a class="control-label" @click="cancel">Log in to an existing account</a>
              </div>
            </div>
          </form>
        </div>
        <div slot="footer">
          <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
          <va-button :isBlock="false" theme="success" name="Create" align="right" @click.native="register" style="margin-right: 10px;"></va-button>
          <va-button v-if="0>1" :isBlock="false" theme="success" name="Create Test" align="right" @click.native="registerTest" style="margin-right: 10px;"></va-button>
        </div>
      </va-box>
      <va-alert type="danger" :dismissible="true" v-show="error">
        <div slot="body">
          <i class="icon fa fa-ban"></i> {{error}}
        </div>
      </va-alert>
      <va-modal></va-modal>
    </column>
    <column class="col-md-3"></column>
    <loading :active.sync="$root.isLoading"></loading>
  </row>
</template>
<script>
  import VAAlert from '../components/VAAlert'
  import Modal from '../components/Modal'
  import VABox from '../components/VABox'
  import VAButton from '../components/VAButton'
  import Loading from 'vue-loading-overlay'
  import { db, auth, createAuth, func } from '../firebase'
  import short from 'short-uuid'

  export default {
    name: 'va-register',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        isLocal: false,
        // isLoading: false,
        firstName: '',
        lastName: '',
        companyName: '',
        username: '',
        confirmUsername: '',
        password: '',
        confirmPassword: '',
        phone: '',
        country: '',
        error: ''
      }
    },
    created () {
      this.isLoading = false
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        // alert('It is a local server!')
        this.isLocal = true
      }
      // this.isLocal = true
    },
    updated () {
      this.isLoading = false
    },
    components: {
      'va-modal': Modal,
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      Loading
    },
    methods: {
      fillDefaultAccount () {
        let vm = this
        // let translator = short()
        // let shortUID = translator.generate()
        vm.firstName = 'Abed'
        vm.lastName = 'Ali'
        vm.companyName = 'Epaper LTD'
        // vm.username = shortUID + '@printercounters.com'
        // vm.confirmUsername = shortUID + '@printercounters.com'
        vm.username = 'abed@abed.com'
        vm.confirmUsername = 'abed@abed.com'
        vm.password = '123456'
        vm.confirmPassword = '123456'
        vm.country = 'Israel'
        vm.phone = '+972503209977'
        // vm.register()
      },
      registerTest () {
        let vm = this
        // let translator = short()
        // let shortUID = translator.generate()
        vm.firstName = 'Abed'
        vm.lastName = 'Ali'
        vm.companyName = ''
        // vm.username = shortUID + '@printercounters.com'
        // vm.confirmUsername = shortUID + '@printercounters.com'
        vm.username = 'getnetsystem@gmail.com'
        vm.confirmUsername = 'getnetsystem@gmail.com'
        vm.password = '123456'
        vm.confirmPassword = '123456'
        vm.country = 'IL'
        vm.register()
      },
      registerBK () {
        console.log('create account')
        const vm = this
        if (vm.isValid()) {
          vm.$root.isLoading = true
          auth.createUserWithEmailAndPassword(vm.username, vm.password).then(function () {
            auth.currentUser.sendEmailVerification().then(function () {
              // const dealerUID = auth.currentUser.uid
              const user = {
                FirstName: vm.firstName,
                LastName: vm.lastName,
                Email: auth.currentUser.email,
                UserType: 'Dealer',
                DealerUID: auth.currentUser.uid,
                Country: vm.country,
                Phone: vm.phone,
                Verified: auth.currentUser.emailVerified,
                Locked: false,
                Connected: false
              }

              const dealer = {
                FullName: user.FirstName + ' ' + user.LastName,
                TotalCustomers: 0,
                TotalSites: 0,
                TotalPrinters: 0
              }

              const userRef = db.ref('Users/' + auth.currentUser.uid)
              userRef.set(user)

              const dealerRef = db.ref('Dealers/' + auth.currentUser.uid)
              dealerRef.set(dealer)

              vm.$notify({
                type: 'success',
                title: 'Registration Success',
                text: 'You have successfully registered to Printer Counter'
              })

              let contact = {
                Logged: now.format('YYYY-MM-DD HH:mm:ss'),
                LoggedInt: Number(now.format('YYYYMMDDHHmm')),
                FullName: vm.firstName + ' ' + vm.lastName,
                Email: auth.currentUser.email,
                Message: 'System Message: New Dealer account was created.',
                IsRead: false
              }
              db.ref('Contact').push(contact)

              let translator = short()
              let shortUID = translator.generate()

              const siteAuthUser = {
                FirstName: 'Site',
                LastName: 'Auth',
                Email: shortUID + '@printercounters.com',
                DealerUID: auth.currentUser.uid,
                UserType: 'SiteAuth',
                Country: vm.country,
                Verified: false,
                Locked: false,
                Connected: false
              }

              createAuth.createUserWithEmailAndPassword(siteAuthUser.Email, shortUID).then(function () {
                const userRef = db.ref('Users/' + createAuth.currentUser.uid)
                userRef.set(siteAuthUser)
              })

              db.ref('Settings/' + auth.currentUser.uid).set({ SearchPrintersEvery: 7, SendPrintersEvery: 28 })

              db.ref('Dashboard/Admin/TotalDealers').once('value').then(function (snapTotalDealers) {
                let totalDealers = snapTotalDealers.val()
                db.ref('Dashboard/Admin/TotalDealers').set(totalDealers + 1)
              })
              console.log('Your account was created succesfully')
              vm.$root.isLoading = false
              vm.$root.goto('Thanks')
            }, function (error) {
              vm.$root.isLoading = false
              vm.error = error.code + ': ' + error.message
            })
          }, function (error) {
            vm.$root.isLoading = false
            vm.error = error.code + ': ' + error.message
          })
        }
      },
      register () {
        console.log('create account')
        const vm = this
        if (vm.isValid()) {
          vm.$root.isLoading = true
          auth.createUserWithEmailAndPassword(vm.username, vm.password).then(function () {
            let translator = short()
            let verifyCode = translator.generate()
            var now = vm.$moment()
            var nextWeek = now.add(7, 'days')
            let verify = {
              Created: now.format('YYYYMMDDHHmmss'),
              Expired: nextWeek.format('YYYYMMDDHHmmss'),
              Email: auth.currentUser.email,
              Code: verifyCode
            }
            console.log('Add Verifications record to db')
            const verifyRef = db.ref('Verifications/' + auth.currentUser.uid)
            verifyRef.set(verify)

            // const dealerUID = auth.currentUser.uid
            const user = {
              FirstName: vm.firstName,
              LastName: vm.lastName,
              CompanyName: vm.companyName,
              Email: auth.currentUser.email,
              Password: vm.password,
              UserType: 'Dealer',
              DealerUID: auth.currentUser.uid,
              Country: vm.country,
              Phone: vm.phone,
              Verified: false,
              Locked: false,
              Connected: false,
              CreateDate: vm.$moment().format('YYYY-MM-DD HH:mm:ss')
            }

            const dealer = {
              FullName: user.FirstName + ' ' + user.LastName,
              CreateDate: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
              TotalCustomers: 0,
              TotalSites: 0,
              TotalPrinters: 0,
              InstallerLinks: {
                Lan: '',
                Usb: ''
              }
            }

            console.log('Add User record to db')
            const userRef = db.ref('Users/' + auth.currentUser.uid)
            userRef.set(user)

            console.log('Add Dealer record to db')
            const dealerRef = db.ref('Dealers/' + auth.currentUser.uid)
            dealerRef.set(dealer)

            let dealerKey = auth.currentUser.uid

            console.log('Add Alerts new account created')
            db.ref('Alerts').push({
              Title: 'Dealer Account created',
              Type: 'System',
              Message: 'Your Dealer account is ready, now you can start monitoring your USB and LAN Printers.',
              Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
              LoggedInt: vm.$moment().format('YYYYMMDDHHmmss'),
              DealerKey: dealerKey,
              CustomerKey: 'All',
              DealerCustomerKey: dealerKey + '_All',
              DateDealerKey: dealerKey + '_' + vm.$moment().format('YYYYMMDDHHmmss'),
              DateDealerCustomerKey: dealerKey + '_All_' + vm.$moment().format('YYYYMMDDHHmmss')
            })

            console.log('Show UI notification')
            vm.$notify({
              type: 'success',
              title: 'Registration Success',
              text: 'You have successfully registered to Printer Counter'
            })
            let messageNewDealer = ''
            messageNewDealer += 'System Message: New Dealer account was created. '
            // messageNewDealer += '<a target="_blank" href="Dealer/' + dealerKey + '">'
            // messageNewDealer += 'View Dealer'
            // messageNewDealer += '</a>.'
            let messageLogged = vm.$moment().format('YYYY-MM-DD HH:mm:ss')
            let messageLoggedInt = vm.$moment().format('YYYYMMDDHHmm')
            let contact = {
              Logged: messageLogged,
              LoggedInt: Number(messageLoggedInt),
              FullName: vm.firstName + ' ' + vm.lastName,
              Email: auth.currentUser.email,
              Message: messageNewDealer,
              DealerKey: dealerKey,
              IsRead: false
            }
            console.log('Add Contact inbox record to db')
            db.ref('Contact').push(contact)

            db.ref('Settings/' + auth.currentUser.uid).set({ SearchPrintersEvery: 7, SendPrintersEvery: 28 })

            console.log('Update Dealer Dashboard [TotalDealers++] to db')
            db.ref('Dashboard/Admin/TotalDealers').once('value').then(function (snapTotalDealers) {
              let totalDealers = snapTotalDealers.val()
              db.ref('Dashboard/Admin/TotalDealers').set(totalDealers + 1)
            })
            let shortUID = translator.generate()
            const siteAuthUser = {
              FirstName: 'Site',
              LastName: 'Auth',
              CompanyName: vm.companyName,
              Email: shortUID + '@printercounters.com',
              Password: shortUID,
              DealerUID: auth.currentUser.uid,
              UserType: 'SiteAuth',
              Country: vm.country,
              Verified: false,
              Locked: false,
              Connected: false,
              CreateDate: vm.$moment().format('YYYY-MM-DD HH:mm:ss')
            }
            createAuth.createUserWithEmailAndPassword(siteAuthUser.Email, shortUID).then(function () {
              const userRef = db.ref('Users/' + createAuth.currentUser.uid)
              userRef.set(siteAuthUser)

              db.ref('Alerts').push({
                Title: 'Auto-Generated Auth key for your account',
                Type: 'System',
                Message: 'Your Auth key is: ' + createAuth.currentUser.uid,
                Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
                LoggedInt: vm.$moment().format('YYYYMMDDHHmmss'),
                DealerKey: dealerKey,
                CustomerKey: 'All',
                DealerCustomerKey: dealerKey + '_All',
                DateDealerKey: dealerKey + '_' + vm.$moment().format('YYYYMMDDHHmmss'),
                DateDealerCustomerKey: dealerKey + '_All_' + vm.$moment().format('YYYYMMDDHHmmss')
              })

              db.ref('ApiFunctions/InstallerRootAddress').once('value').then(function (snapInstallerRootAddress) {
                let installerRootAddress = snapInstallerRootAddress.val()
                console.log('vm.$root.installerRootAddress = ' + installerRootAddress)
                var GenerateDealerMSI = func.httpsCallable('GenerateDealerMSI')
                var UID = createAuth.currentUser.uid
                GenerateDealerMSI({ UID: UID }).then((result) => {
                  console.log(result)
                  dealer.InstallerLinks = {
                    Lan: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Network/NetworkPrinterCounters@' + UID + '@.msi',
                    Usb: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Local/LocalPrinterCounters@' + UID + '@.msi'
                  }
                  dealerRef.set(dealer)

                  let message = ''
                  message += 'To start monitoring your Network Printers click '
                  message += '<a target="_blank" href="' + dealer.InstallerLinks.Lan + '" class="lnkDownload">'
                  message += 'Download LAN Installer'
                  message += '</a>.'
                  console.log(message)
                  db.ref('Alerts').push({
                    Title: 'Download LAN Installer',
                    Type: 'System',
                    Message: message,
                    Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    LoggedInt: vm.$moment().format('YYYYMMDDHHmmss'),
                    DealerKey: dealerKey,
                    CustomerKey: 'All',
                    DealerCustomerKey: dealerKey + '_All',
                    DateDealerKey: dealerKey + '_' + vm.$moment().format('YYYYMMDDHHmmss'),
                    DateDealerCustomerKey: dealerKey + '_All_' + vm.$moment().format('YYYYMMDDHHmmss')
                  })
                  message = ''
                  message += 'To start monitoring your Usb Printers click '
                  message += '<a target="_blank" href="' + dealer.InstallerLinks.Usb + '" class="lnkDownload">'
                  message += 'Download USB Installer'
                  message += '</a>.'
                  console.log(message)
                  db.ref('Alerts').push({
                    Title: 'Download USB Installer',
                    Type: 'System',
                    Message: message,
                    Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    LoggedInt: vm.$moment().format('YYYYMMDDHHmmss'),
                    DealerKey: dealerKey,
                    CustomerKey: 'All',
                    DealerCustomerKey: dealerKey + '_All',
                    DateDealerKey: dealerKey + '_' + vm.$moment().format('YYYYMMDDHHmmss'),
                    DateDealerCustomerKey: dealerKey + '_All_' + vm.$moment().format('YYYYMMDDHHmmss')
                  })
                })
              })

              let emailData = {
                SendTo: auth.currentUser.email,
                Subject: 'Verify your email for Printer Counters - Thank you',
                Template: 'verify.html',
                TemplateData: {
                  FirstName: vm.firstName,
                  LastName: vm.lastName,
                  Date: now.format('DD/MM/YYYY HH:mm:ss'),
                  VerifcationEmail: auth.currentUser.email,
                  VerifcationCode: verifyCode
                }
              }
              vm.SendVerificationEmail(vm, emailData, function (result) {
                let emailDataWelcome = {
                  SendTo: auth.currentUser.email,
                  Subject: 'Thank you for choosing Printer Counters',
                  Template: 'welcome.html',
                  TemplateData: {
                    FirstName: vm.firstName,
                    LastName: vm.lastName,
                    Date: vm.$moment().format('DD/MM/YYYY HH:mm:ss'),
                    AuthKey: createAuth.currentUser.uid
                  }
                }
                vm.SendWelcomeEmail(vm, emailDataWelcome, function (result) {
                  console.log(result)
                  vm.$root.isLoading = false
                  console.log('Your account was created succesfully')
                  vm.$root.goto('Thanks')
                })
              })
            })
          }, function (error) {
            vm.$root.isLoading = false
            vm.error = error.code + ': ' + error.message
          })
        }
      },
      SendVerificationEmail (vm, emailData, callback) {
        console.log('SendVerificationEmail')
        let query = '?Data=' + JSON.stringify(emailData)
        let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendEmail' + query
        // let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          callback({ Success: false, Data: response.data })
        })
          .catch(function (error) {
            callback({ Success: false, Data: error })
          })
      },
      SendWelcomeEmail (vm, emailData, callback) {
        console.log('SendWelcomeEmail')
        let query = '?Data=' + JSON.stringify(emailData)
        let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendEmail' + query
        // let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          callback({ Success: false, Data: response.data })
        }).catch(function (error) {
          callback({ Success: false, Data: error })
        })
      },
      autoLogin (vm) {
        console.log('autoLogin')
        vm.$root.logout()
        auth.signInWithEmailAndPassword(vm.username, vm.password).then(function () {
          console.log(auth.currentUser)
          const userRef = db.ref('Users/' + auth.currentUser.uid)
          userRef.once('value').then(function (snapUser) {
            let userData = snapUser.val()
            // providerData
            console.log(userData)
            if (userData) {
              userData['.key'] = auth.currentUser.uid
              userData.Connected = true
              vm.$root.user = userData
              db.ref('Users/' + auth.currentUser.uid + '/Connected').set(true)

              if (!userData.Verified && auth.currentUser.emailVerified) {
                db.ref('Users/' + auth.currentUser.uid + '/Verified').set(auth.currentUser.emailVerified)
                vm.$root.user.Verified = auth.currentUser.emailVerified
              }
              console.log(vm.$root.user)
              vm.$localStorage.set('user', JSON.stringify(vm.$root.user))

              vm.$root.checkUser()
            } else {
              vm.alertType = 'danger'
              vm.error = '* Login failed, please try again!'
            }
          })
        }, function (error) {
          vm.alertType = 'danger'
          vm.error = error.code + ': ' + error.message
        })
      },
      showSuccess (vm) {
        vm.$bus.$emit('modal-open', {
          title: 'Register',
          description: 'Your account was succesfully created, Now you can login to your account.',
          type: 'modal-primary',
          confirmText: 'Login',
          cancelText: 'Close',
          confirmBefore: () => {
            // window.alert('confirmBefore')
          },
          confirmAfter: () => {
            vm.$root.goto('Login')
          },
          cancelBefore: () => {
            // window.alert('cancelBefore')
          },
          cancelAfter: () => {
            // window.alert('cancelAfter')
          }
        })
      },
      cancel () {
        console.log('cancel')
        const vm = this
        vm.username = ''
        vm.password = ''

        vm.$root.goto('Login')
      },
      isValid () {
        this.error = ''
        if (this.firstName.trim().length === 0) {
          this.error = '* Please enter your First Name!'
          return false
        }

        if (this.lastName.trim().length === 0) {
          this.error = '* Please enter your Last Name!'
          return false
        }

        if (this.companyName.trim().length === 0) {
          this.error = '* Please enter your Company Name!'
          return false
        }

        if (this.username.trim().length === 0) {
          this.error = '* Please enter your Email Address!'
          return false
        }

        if (this.validateEmail(this.username)) {

        } else {
          this.error = '* Invalid Email Address!'
          return false
        }

        if (this.confirmUsername !== this.username) {
          this.error = '* Please confirm your Email Address!'
          return false
        }

        if (this.password.trim().length < 6) {
          this.error = '* Password length must be at least 6 characters'
          return false
        }

        if (this.password !== this.confirmPassword) {
          this.error = '* Please confirm your password!'
          return false
        }

        // regex = /^\+(?:[0-9] ?){6,14}[0-9]$/
        // regex = /^(?:(\+))?(?:[0-9]{0,3}[\s.\/-]?)?(?:(?:\((?=\d{3}\)))?(\d{3})(?:(?!\(\d{3})\))?[\s.\/-]?)?(?:(?:\((?=\d{3}\)))?(\d{3})(?:(?!\(\d{3})\))?[\s.\/-]?)?(?:(?:\((?=\d{4}\)))?(\d{4})(?:(?!\(\d{4})\))?[\s.\/-]?)?$/;
        // regex = /^\+[0-9]?()[0-9](\s|\S)(\d[0-9]{9})$/
        // console.log(regex)

        if (this.phone.length > 0) {
          // if (regex.test(this.phone)) {
          // } else {
          //   this.error = '* Invalid phone number!'
          //   return false
          // }
        } else {
          this.error = '* Invalid phone number!'
          return false
        }

        return true
      },
      validateEmail (email) {
        return true
        // var mailformat = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/
        // return email.match(mailformat)
        // return true

        // return email.match(
        //  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // )
      },
      isValidLogin (username, password) {
        return true
      },
      checkBlockedUser () {
        return false
      }
    }
  }
</script>

<style lang="css" scoped>

  .modal-example .modal {
    position: relative;
    top: auto;
    bottom: auto;
    right: auto;
    left: auto;
    display: block;
    z-index: 1;
  }

  .modal-example .modal {
    background: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// VARegister.vue?7433f86c